import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchDailyRouteLeadingCountUseEdiAPI = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'useEdiRouteLeadingCountStatus',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    assetRouteId: payload.params.assetRouteId,
    effectiveDate: moment(payload.params.effectiveDate).format('YYYY-MM-DD'),
  });
};

export const apiFetchDailyRouteLeadingCountUseMaxAPI = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'useMaxRouteLeadingCountStatus',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    assetRouteId: payload.params.assetRouteId,
    effectiveDate: moment(payload.params.effectiveDate).format('YYYY-MM-DD'),
  });
};
